const EMPTY_CHAR = '\u00A0';
const DEFAULT_TEST_ID = 'crypto-address';

export { DEFAULT_TEST_ID, EMPTY_CHAR };
